export default {
    nav: {
        home: 'Accueil',
        products: 'Produits',
        solutions: 'Solutions',
        support: 'Assistance',
        aboutUs: 'À propos de nous',
        contact: 'Contactez-nous'
    },
    hero: {
        title: 'Kooyii Smart<br>Solutions complètes d\'espaces intelligents et d\'alarmes',
        desc: 'Rendre les espaces plus intelligents, plus sûrs et plus sécurisés.'
    },
    protocol: {
        title: 'Protocoles de communication',
        cards: {
            zigbee: 'Zigbee 3.0 est une norme de communication sans fil unifiée introduite par la Connectivity Standards Alliance (CSA), permettant une interopérabilité fluide entre les marques et des réseaux maillés à faible consommation en intégrant des protocoles d\'applications fragmentés.',
            wifi: 'Le Wi-Fi est une technologie de réseau sans fil mondialement reconnue qui transmet des données via des ondes radio, permettant aux appareils de se connecter aux réseaux sans câbles physiques.',
            rf433: 'Le 433 MHz est une bande radio basse fréquence couramment utilisée pour les appareils à courte portée et à faible consommation tels que les systèmes d\'alarme de sécurité et les interrupteurs intelligents.',
            modbus: 'Modbus est un protocole de communication série largement utilisé dans l\'automatisation industrielle, prenant en charge la communication maître-esclave et l\'échange de données.',
            knx: 'KNX est une technologie de bus standard européenne largement utilisée dans les systèmes domotiques pour les bâtiments intelligents.',
            bluetooth: 'Le Bluetooth est une technologie sans fil pour la communication entre appareils, largement utilisée dans les hôtels intelligents, la domotique et d\'autres domaines.'
        }
    },
    services: {
        title: 'Scénarios d\'application',
        features: {
            smartHome: {
                title: 'Maison Intelligente',
                desc: 'Brisez les limites des maisons traditionnelles pour créer un espace de vie intelligent pour tous les scénarios. Prenant en charge plusieurs protocoles tels que Zigbee et Wi-Fi, il permet l\'interconnectivité des appareils et le changement de scènes en toute fluidité. Débloquez un style de vie hautement efficace et pratique avec des opérations minimalistes, apportant la chaleur de la technologie à votre quotidien.'
            },
            security: {
                title: 'Sécurité Intelligente',
                desc: 'Une centrale d\'alarme associée à une plateforme de surveillance professionnelle pour construire un système de sécurité intégré. En tant que cœur du système, la centrale se connecte à divers détecteurs (infrarouges, fumée, boutons d\'urgence) via le protocole 433 MHz, permettant des alertes en temps réel pour les intrusions, les incendies et les urgences.'
            },
            hotel: {
                title: 'Hôtel Intelligent',
                desc: 'Centrée sur l\'IoT et associée à une plateforme de gestion des équipements hôteliers, cette solution connecte les chambres intelligentes, les opérations de la réception et les services en chambre, offrant une double valeur aux clients ainsi qu\'à la direction de l\'hôtel.'
            },
            building: {
                title: 'Automatisation de Bâtiments',
                desc: 'Basé sur RTU et configuré via un back-office de gestion, il prend en charge l\'intégration des appareils Modbus pour réaliser facilement une surveillance centralisée, un contrôle intelligent et la gestion énergétique des équipements du bâtiment, transformant ainsi les bâtiments traditionnels en bâtiments intelligents.'
            }
        }
    },
    software: {
        title: 'Logiciels et Plateformes',
        steps: {
            cms: { title: 'Centre de Télésurveillance', desc: 'Cliquez pour visiter' },
            kooyii: { title: 'Kooyii', desc: 'Survolez pour scanner et télécharger' },
            elderly: { title: 'Assistance aux Personnes Âgées', desc: 'Expérience non disponible actuellement. Contactez les ventes pour plus de détails.' },
            hotel: { title: 'Hôtel Intelligent', desc: 'Expérience non disponible actuellement. Contactez les ventes pour plus de détails.' },
            building: { title: 'Automatisation de Bâtiments', desc: 'Expérience non disponible actuellement. Contactez les ventes pour plus de détails.' },
            more: { title: 'Plus de Scénarios', desc: 'Veuillez contacter nos ventes pour des conseils professionnels.' }
        }
    },
    solutions: {
        services: {
            title: 'Nos Services',
            features: {
                hardware: {
                    title: 'Personnalisation Matérielle',
                    desc: 'Services exclusifs de conception et de fabrication de bout en bout, des cartes PCBA centrales à l\'esthétique complète de l\'appareil. Couvre la conception des circuits, la sélection des composants, le routage PCB, le débogage fonctionnel, les moules de boîtier, les matériaux et la protection structurelle.'
                },
                software: {
                    title: 'Personnalisation Logicielle',
                    desc: 'Développement d\'applications sur mesure et de systèmes web en fonction de vos besoins commerciaux réels, incluant les applications mobiles (iOS/Android), les pages web pour PC et la gestion back-office. Fournit une solution numérique hautement efficace adaptée à votre modèle opérationnel.'
                },
                server: {
                    title: 'Déploiement Privé',
                    desc: 'Déployez des systèmes, des plateformes ou des applications entièrement sur vos propres serveurs ou environnements intranet désignés. Les données et les services fonctionnent de manière totalement indépendante, permettant un contrôle autonome total.'
                }
            }
        },
        whyUs: {
            title: 'Pourquoi Nous Choisir ?',
            benefits: {
                oneStop: {
                    title: 'Service Tout-en-Un',
                    desc: 'Nos solutions couvrent à la fois les logiciels et le matériel avec un alignement complet et unifié, éliminant la coordination entre plusieurs parties, raccourcissant les cycles de développement et réduisant les coûts de communication.'
                },
                custom: {
                    title: 'Personnalisation Poussée',
                    desc: 'Les fonctionnalités logicielles sont précisément adaptées aux performances matérielles, évitant les problèmes de compatibilité et garantissant un fonctionnement global plus fluide avec des taux de panne plus faibles.'
                },
                expandable: {
                    title: 'Haute Évolutivité',
                    desc: 'Nos services réservent des interfaces d\'extension, facilitant la mise à niveau et l\'expansion des fonctionnalités par les clients en fonction de leurs besoins futurs.'
                },
                deployment: {
                    title: 'Déploiement Flexible',
                    desc: 'Qu\'il s\'agisse d\'un déploiement privé localisé ou d\'un déploiement sur cloud public, nous fournissons des solutions flexibles pour répondre à vos besoins.'
                }
            }
        },
        cta: {
            title: 'Prêt à améliorer votre style de vie ?',
            desc: 'Parlez dès aujourd\'hui à nos experts en maisons intelligentes et laissez-nous concevoir l\'écosystème parfait pour vous.',
            button: 'Contacter les Ventes'
        }
    },
    product: {
        nav: {
            panel: 'Panneaux de Contrôle',
            hub: 'Passerelles Intelligentes',
            switch: 'Interrupteurs Intelligents',
            curtain: 'Rideaux Intelligents',
            sensor: 'Capteurs',
            lighting: 'Éclairage Intelligent',
            security: 'Sécurité Intelligente',
            doorlock: 'Serrures Intelligentes'
        },
        sub: {
            '4inch': '4 Pouces',
            '5inch': '5 Pouces',
            '6inch': '6 Pouces',
            '7inch': '7 Pouces',
            '8inch': '8 Pouces',
            '10inch': '10 Pouces',
            '1gang': '1 Voie',
            '2gang': '2 Voies',
            '3gang': '3 Voies',
            '4gang': '4 Voies',
            wireless: 'Sans fil',
            wired: 'Filaire',
            'openclose': 'Moteur de Rideau',
            'roller': 'Store Enrouleur',
            'downlight': 'Spots et Downlights',
            'magnetic': 'Éclairage sur Rail Magnétique',
            'strip': 'Bandeaux LED',
            'alarm': 'Centrale d\'Alarme',
            'door': 'Capteur d\'Ouverture',
            'smoke': 'Détecteur de Fumée',
            'infrared': 'Détecteur Infrarouge',
            'radar': 'Radar de Présence Humaine',
            'water': 'Détecteur de Fuite d\'Eau',
            'temp': 'Capteur de Temp. & Humidité',
            'indoorCam': 'Caméra Intérieure',
            'outdoorCam': 'Caméra Extérieure',
            'password': 'Serrure à Code',
            'fingerprint': 'Serrure à Empreinte Digitale',
            'face': 'Serrure à Reconnaissance Faciale'
        },
        common: {
            learnMore: 'En savoir plus',
            addToCart: 'Ajouter au panier',
            buyNow: 'Acheter maintenant',
            emptyProduct: 'Aucun produit associé pour le moment. Restez à l\'écoute...'
        },
        cart: {
            titleList: 'Liste de Demandes',
            titleForm: 'Remplir les Informations de Contact',
            empty: 'Votre liste est vide, allez ajouter des produits !',
            delete: 'Supprimer',
            totalItems: 'Total de {count} produits sélectionnés',
            nextStep: 'Étape Suivante : Remplir les Informations',
            submit: 'Soumettre la Demande'
        },
        form: {
            name: 'Comment devons-nous vous appeler ?',
            namePlaceholder: 'Veuillez entrer votre nom',
            address: 'Adresse de l\'entreprise',
            addressPlaceholder: 'Veuillez entrer l\'adresse détaillée de votre entreprise',
            location: 'Ville / Pays',
            locationPlaceholder: 'Ex. : Paris, France',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Entrez votre WhatsApp pour que nous puissions vous contacter',
            email: 'E-mail',
            emailPlaceholder: 'Entrez votre e-mail pour que nous puissions vous contacter',
            remark: 'Remarques',
            remarkPlaceholder: 'Entrez des remarques pour que nous puissions mieux comprendre vos besoins',
            zipCode: 'Code Postal',
            zipCodePlaceholder: 'Entrez votre code postal'
        },
        alert: {
            fillRequired: 'Veuillez remplir tous les champs obligatoires (marqués d\'un *)',
            submitSuccess: 'Demande soumise avec succès ! Notre équipe de vente vous contactera sous peu.',
            confirm: 'Confirmer',
            notice: 'Avis',
            success: 'Succès !'
        }
    },
    contact: {
        hero: {
            title: 'Contactez-Nous',
            desc: 'Obtenez des conseils professionnels et les solutions les plus adaptées pour vous'
        },
        form: {
            title: 'Envoyez-nous un message',
            subtitle: 'Remplissez le formulaire ci-dessous et nous vous répondrons dans les 24 heures.',
            firstName: 'Prénom',
            firstNamePlaceholder: 'Ex. : Jean',
            lastName: 'Nom',
            lastNamePlaceholder: 'Ex. : Dupont',
            email: 'E-mail professionnel',
            emailPlaceholder: "jean{'@'}entreprise.com",
            inquiryType: 'Type de demande',
            selectTopic: 'Sélectionnez un sujet...',
            message: 'Message',
            messagePlaceholder: 'Comment pouvons-nous vous aider ?',
            submitBtn: 'Envoyer le message',
            sending: 'Envoi en cours...',
            successMsg: 'Merci ! Votre message a été envoyé avec succès.'
        },
        inquiry: {
            general: 'Question Générale',
            sales: 'Ventes & Distribution',
            support: 'Support Technique',
            hardware: 'OEM/ODM',
        },
        location: {
            title: 'Où Nous Sommes',
            officeName: 'Siège Social de Shenzhen',
            address: 'Bureau 603, Unité 1, Bâtiment 1, Place Kailifang, Rue Lianrun, Communauté Taoyuan, Quartier Dalang, District de Longhua, Shenzhen, Guangdong, Chine',
            phone: '+86 18926403313 Mme Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}